export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8752.b3bca4c9.jpg";